window.Branch = window.Branch || {};
window.Branch.product = window.Branch.product || {};

window.Branch.product.updateFeaturesSection = function(variant){
    let pdpFeaturesSections = document.querySelectorAll(".pdp-features");
    pdpFeaturesSections.forEach((pdpFeaturesSection) => {
        let allDefaultImages = pdpFeaturesSection.querySelectorAll(`.pdp-features__slide-media.pdp-features__slide-media--default`);
        let allDefaultSubtitles = pdpFeaturesSection.querySelectorAll(`.pdp-features__slide-subtitle.pdp-features__slide-subtitle--default`);
        let allDefaultTitles = pdpFeaturesSection.querySelectorAll(`.pdp-features__slide-title.pdp-features__slide-title--default`);

        allDefaultImages.forEach((defaultImage) => {
            defaultImage.style.display = "block"
          });
    
          allDefaultSubtitles.forEach((defaultSubtitle) => {
            defaultSubtitle.style.display = "block"
          })

          allDefaultTitles.forEach((defaultTitle) => {
            defaultTitle.style.display = "block"
          })
    
    if(variant){
        let altVariantImages = pdpFeaturesSection.querySelectorAll(`.pdp-features__slide-media[data-variant-id="${variant.id}"]`);
        let allNonDefaultImages = pdpFeaturesSection.querySelectorAll(`.pdp-features__slide-media:not(.pdp-features__slide-media--default)`);
        
        let altVariantSubtitles = pdpFeaturesSection.querySelectorAll(`.pdp-features__slide-subtitle[data-variant-id="${variant.id}"]`);
        let allNonDefaultSubtitles = pdpFeaturesSection.querySelectorAll(`.pdp-features__slide-subtitle:not(.pdp-features__slide-subtitle--default)`);
        
        let altVariantTitles = pdpFeaturesSection.querySelectorAll(`.pdp-features__slide-title[data-variant-id="${variant.id}"]`);
        let allNonDefaultTitles = pdpFeaturesSection.querySelectorAll(`.pdp-features__slide-title:not(.pdp-features__slide-title--default)`);
     
        if(allNonDefaultImages.length > 0 ){
          allNonDefaultImages.forEach(( nonDefaultImage) => {
            nonDefaultImage.style.display = "none"
          })
        }
  
        if(allNonDefaultSubtitles.length > 0 ){
          allNonDefaultSubtitles.forEach(( nonDefaultSubtitle) => {
            nonDefaultSubtitle.style.display = "none"
          })
        }

        if(allNonDefaultTitles.length > 0 ){
          allNonDefaultTitles.forEach(( nonDefaultTitle) => {
            nonDefaultTitle.style.display = "none"
          })
        }
        
        if(altVariantImages.length > 0){
          altVariantImages.forEach((altVariantImage) => {
            altVariantImage.parentElement.querySelectorAll('.pdp-features__slide-media').forEach((slideMedia) => {
              slideMedia.style.display = 'none';
            })
            altVariantImage.style.display = "block";
          })
        } 

        if(altVariantSubtitles.length > 0){
          altVariantSubtitles.forEach((altVariantSubtitle) => {
            altVariantSubtitle.parentElement.querySelectorAll('.pdp-features__slide-subtitle').forEach((slideSubtitle) => {
              slideSubtitle.style.display = 'none';
            })
            altVariantSubtitle.style.display = "block";
          })
        } 

        if(altVariantTitles.length > 0){
          altVariantTitles.forEach((altVariantTitle) => {
            altVariantTitle.parentElement.querySelectorAll('.pdp-features__slide-title').forEach((slideTitle) => {
              slideTitle.style.display = 'none';
            })
            altVariantTitle.style.display = "block";
          })
        } 
    }

    })
}         

$(function(){
    function filterSlidesByTab(sliderContainer, tabLabel){
        var swiper = sliderContainer._pdpSwiper;
        var allSlides = sliderContainer._pdpAllSlides;
        if(!swiper || !allSlides) return;

        var hasTaggedSlides = allSlides.some(function(slide){ return slide.hasAttribute('data-tab'); });
        if(!hasTaggedSlides) return;

        var wrapper = sliderContainer.querySelector('.swiper-wrapper');
        if(!wrapper) return;

        var normalized = (tabLabel || '').replace(/\s+/g, ' ').trim().toLowerCase();

        allSlides.forEach(function(slide){
            if(slide.parentNode) slide.parentNode.removeChild(slide);
        });
        allSlides.forEach(function(slide){
            var slideTab = slide.getAttribute('data-tab');
            if(!slideTab || slideTab === normalized){
                wrapper.appendChild(slide);
            }
        });

        swiper.update();
        swiper.slideTo(0, 0);
    }

    if(!window.__pdpFeaturesTabSyncBound){
        window.__pdpFeaturesTabSyncBound = true;
        document.addEventListener('hype-chair-tab-change', function(e){
            var tabLabel = (e.detail && e.detail.tabLabel) || '';
            document.querySelectorAll('.pdp-features__slider-container').forEach(function(c){
                filterSlidesByTab(c, tabLabel);
            });
        });
    }

    const initPDPFeaturesSlider = function(event){
        if (typeof window.Swiper === 'undefined') {
            if (typeof window.whenSwiperReady === 'function') {
                window.whenSwiperReady(function(){ initPDPFeaturesSlider(event); });
            }
            return;
        }
        let sliderContainers = document.querySelectorAll('.pdp-features__slider-container');

        sliderContainers.forEach((sliderContainer, index) => {
            let autoscroll = false;
            if(sliderContainer.getAttribute('data-enable-autoscroll') == "true"){
                let autoscrollInterval = parseInt(sliderContainer.getAttribute('data-autoscroll-interval')) * 1000;;
                autoscroll = {
                    delay: autoscrollInterval,
                    disableOnInteraction: true
                    }
            }

            let params = {};
            if(event == "gallery-open"){
                params = {
                    slidesPerView: 1,
                    zoom: true,
                    spaceBetween: 0,
                    freeMode: false,
                    autoplay: autoscroll
                    }
            }
            if(event == "load"){
                let sliderElement = sliderContainer.querySelector('.pdp-features__slider');
                params = {
                    slidesPerView: 1.33333333333,
                    spaceBetween: 20,
                    freeMode: false,
                    autoplay: autoscroll,
                    navigation: {
                        nextEl: sliderContainer.querySelector('.pdp-features__right-arrow.swiper-button-next'),
                        prevEl: sliderContainer.querySelector('.pdp-features__left-arrow.swiper-button-prev'),
                    },
                    breakpoints: {
                        600: {
                            slidesPerView: 2.5,
                            spaceBetween: 40,
                            freeMode: false,
                            autoplay: autoscroll,
                            navigation: {
                                nextEl: sliderContainer.querySelector('.pdp-features__right-arrow.swiper-button-next'),
                                prevEl: sliderContainer.querySelector('.pdp-features__left-arrow.swiper-button-prev'),
                            }
                        },
                        1024: {
                            slidesPerView: 3.5,
                            spaceBetween: 40,
                            freeMode: false,
                            autoplay: autoscroll,
                            navigation: {
                                nextEl: sliderContainer.querySelector('.pdp-features__right-arrow.swiper-button-next'),
                                prevEl: sliderContainer.querySelector('.pdp-features__left-arrow.swiper-button-prev'),
                            }
                        }
                    },
                        on: {
                            init: function(){
                                if(this && this.slides[this.activeIndex] && this.slides[this.activeIndex].querySelector('video')){
                                    if(window.Branch.functions.isTouchDevice() == true){
                                        this.slides[this.activeIndex].querySelector('video').play();
                                    }
                                }
                            },
                            activeIndexChange: function () {
                                if(window.Branch.functions.isTouchDevice() == true){
                                    this.slides.forEach((slide) => {
                                        if(slide.querySelector('video')){
                                            slide.querySelector('video').pause();
                                        }
                                        console.log('slide.classList', slide.classList.contains('swiper-slide-active'))
                                        // if(slide.classList.contains('swiper-slide-active')){
                                        //     slide.querySelector('video').play();
                                        // }
                                        
                                    })
                                    if(this && this.slides[this.activeIndex] && this.slides[this.activeIndex].querySelector('video')){
                                        this.slides[this.activeIndex].querySelector('video').play();
                                    }
                                }
                            }
                    }
                }
                var pdpFeaturesSwiper = new Swiper(sliderElement, params);

                sliderContainer._pdpSwiper = pdpFeaturesSwiper;
                sliderContainer._pdpAllSlides = Array.from(sliderElement.querySelectorAll('.swiper-slide'));

                var initialActiveBtn = document.querySelector('.hype-chair-tabs .hype-chair-tabs__button[data-active="true"]');
                if(initialActiveBtn){
                    filterSlidesByTab(sliderContainer, (initialActiveBtn.innerText || initialActiveBtn.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase());
                }
            }
        })
    }


    const initHoverVideoPlay = function(video){
        video.addEventListener('mouseenter', function() {
            video.play();
        });
        video.addEventListener('mouseleave', function() {
            video.pause();
        });    
    }

    const initVideos = function(){
        let videos = document.querySelectorAll('.pdp-features__slider-container video');
        videos.forEach((video) => {
            function addLoadedClass() {
                video.setAttribute('data-video-loaded', true);
            }
    
            if (video.readyState >= 2) {
                addLoadedClass();
            } else {
                video.addEventListener('loadeddata', addLoadedClass);
            }


            if(window.Branch.functions.isTouchDevice() == false){
                initHoverVideoPlay(video);
            }
        });
        videos.forEach((video) => {
            video.load();
        })
    }
    
    const initPDPFeatures = function(){
        initVideos();
        initPDPFeaturesSlider("load");
    }
    
    window.addEventListener('load', function(){
        initPDPFeatures();
    });
});
